<template>
  <div class="field-group" :class="{ 'has-error': !!error }">
    <div class="field-heading">
      <label v-if="label" @click="focus" :class="{ 'required': required }">
        {{ label }}
      </label>
    </div>

    <template v-if="hasPermission">
      <div class="relative">
        <input class="text" style="padding-right: 105px;"
          :type="type"
          :value="value"
          :disabled="disabled"
          :placeholder="placeholder"
          @input="update"
          @blur="$emit('blur')"
          ref="input"
        >
        <button type="button" class="absolute z-10 pin-r pin-y text-grey-dark text-xs flex items-center" style="font-size: .6rem;">
          <font-awesome-icon :icon="toggled" class="text-base" @click="toggleInput()" />
          <span @click="generate()" class="ml-2 px-2 py-1 h-full border-l-2 font-semibold tracking-wide uppercase">Genereer</span>
        </button>
      </div>
      <div class="strength-meter" :data-score="score">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <transition name="slide">
        <span v-if="error" class="block form-error text-xs leading-normal">
          {{ error }}
        </span>
      </transition>
    </template>

    <div v-else class="readonly">
      <span v-if="value">{{ value }}</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
import zxcvbn from 'zxcvbn';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon
  },
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    }
  },
  inject: ['$validator'],
  props: {
    value: String,
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    toggle: {
      type: Boolean,
      default: false
    },
    hasPermission: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      required: false
    },
    size: {
      type: Number,
      default: 16
    },
    characters: {
      type: String,
      default: 'a-z,A-Z,0-9,#'
    }
  },
  data() {
    return {
      password: null,
      show: false
    };
  },
  computed: {
    placeholder() {
      return `Voer een ${this.label.toLowerCase()} in`;
    },
    score() {
      return this.password ? zxcvbn(this.password).score : null;
    },
    type() {
      return this.show ? 'text' : 'password';
    },
    toggled() {
      return this.show ? ['fas', 'eye-slash'] : ['fas', 'eye'];
    }
  },
  methods: {
    update(event) {
      this.password = event.target.value;
      this.$emit('input', event.target.value);
    },
    focus() {
      this.$refs.input.focus();
    },
    toggleInput() {
      this.show = !this.show;
    },
    generate() {
      let regex = this.characters.split(',');
      let pass = '',
        chars = '';

      if (regex.indexOf('a-z') >= 0) {
        chars += 'abcdefghijklmnopqrstuvwxyz';
      }
      if (regex.indexOf('A-Z') >= 0) {
        chars += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
      }
      if (regex.indexOf('0-9') >= 0) {
        chars += '0123456789';
      }
      if (regex.indexOf('#') >= 0) {
        chars += '![]()%&$#@';
      }

      let length = chars.length;
      for (let i = 0; i < this.size; i++) {
        pass += chars.charAt(Math.floor(Math.random() * length));
      }
      this.password = pass;
      this.$emit('input', pass);
    }
  }
};
</script>

<style>
.strength-meter {
  display: flex;
  margin-top: 0.5rem;
  padding: 0 1px;
}
.strength-meter > span {
  flex: 1 1 20%;
  height: 3px;
  background-color: #dddddd;
  border-radius: 0.25rem;
}
.strength-meter > span:not(:last-child) {
  margin-right: 5px;
}

.strength-meter[data-score='0'] > span:nth-child(1) {
  background: darkred;
}

.strength-meter[data-score='1'] > span:nth-child(1),
.strength-meter[data-score='1'] > span:nth-child(2) {
  background: darkred;
}

.strength-meter[data-score='2'] > span:nth-child(1),
.strength-meter[data-score='2'] > span:nth-child(2),
.strength-meter[data-score='2'] > span:nth-child(3) {
  background: orangered;
}

.strength-meter[data-score='3'] > span:nth-child(1),
.strength-meter[data-score='3'] > span:nth-child(2),
.strength-meter[data-score='3'] > span:nth-child(3),
.strength-meter[data-score='3'] > span:nth-child(4) {
  background: yellowgreen;
  width: 60%;
}

.strength-meter[data-score='4'] > span {
  background: green;
}
</style>
